export default "__VITE_ASSET__Cgq9Xloe__"